import React from 'react';
import axios from 'axios';
import GoogleLoginButton from '../components/GoogleLoginButton';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class Login extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			error: undefined,
			requesting: false
		};

		this.onLoginSuccess = this.onLoginSuccess.bind(this);
		this.onLoginError = this.onLoginError.bind(this);
	}

	componentDidMount() {

		if (this.props.isLoggedIn()) {
			this.props.loginSuccess();
		}
	}

	onLoginSuccess(loginObj) {
		this.setState({ requesting: true });

		axios.post('/signIn', {
			tokenId: loginObj.tokenId
		}).then((response) => {
			this.setState({ requesting: false });
			this.props.loginSuccess(response.data.token);
		}).catch((error) => {
			this.setState({ error: error.response.data.error, requesting: false });
		});
	}

	onLoginError(errorMsg) {
		this.setState({ error: errorMsg });
	}

	render() {
		const { state } = this;

		let errorMsgElement = state.error && state.error.length > 1 ? <div><p style={{textAlign: 'center', color: 'red'}}>{state.error}</p></div> : null;
		let progressElement = state.requesting ? <div style={{textAlign: 'center'}}><CircularProgress size={60} /></div> : null;

		return (
			<div>
				<h2 style={{textAlign: 'center'}}>Aplicativos de Bolso - Marketing</h2>
				<GoogleLoginButton
					onSuccess={this.onLoginSuccess}
					onError={this.onLoginError}
				/>
				{ errorMsgElement }
				{ progressElement }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Login.js